/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringOpexDto } from '../../models/backend-monitoring-opex-dto';

export interface MonitoringScenariosOpexesList$Params {
  /**
   * Фильтр по типу затрат. Используйте значения из expenses_type в /api/monitoring/common/enums/.
   */
  expenses_type?: 'materials' | 'other-opexes' | 'products' | 'rents' | 'salaries';
  scenario_id: number;
}

export function monitoringScenariosOpexesList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosOpexesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringOpexDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosOpexesList.PATH, 'get');
  if (params) {
    rb.query('expenses_type', params.expenses_type, {});
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringOpexDto>>;
    }),
  );
}

monitoringScenariosOpexesList.PATH = '/api/monitoring/scenarios/{scenario_id}/opexes/';
